import { Form } from "@circle-react-uikit/Form";
import type { ItemProps } from "@circle-react-uikit/Form/Item";

interface FormItemProps extends ItemProps {
  appendTranslationRoot?: string;
}

export const FormItem = ({
  children,
  name,
  rules = {},
  tooltipText,
  hidePlaceholder = false,
  placeholder,
  inlineReverse = false,
  translationRoot = "live_streams.form",
  appendTranslationRoot,
  hideLabel = false,
  ...props
}: FormItemProps) => (
  <Form.Item
    name={name}
    hideDescription
    translationRoot={
      appendTranslationRoot
        ? `${translationRoot}.${appendTranslationRoot}`
        : translationRoot
    }
    rules={rules}
    hideBorder
    fullWidth
    hidePlaceholder={hidePlaceholder}
    placeholder={placeholder}
    tooltipText={tooltipText}
    inlineReverse={inlineReverse}
    hideLabel={hideLabel}
    {...props}
  >
    {children}
  </Form.Item>
);
